export default __webpack_public_path__ + "static/media/laconic_big@2x.accc4dfa.jpg";